import React from 'react';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import FilingReportTypeSelector from '../Generic/ReportTypeSelector';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import ENUMS from '../../../utils/enums';

const log = new Logger('VAT_BOOK_FILING_VALUES', LOG_LEVELS.DEBUG);
class VATBookFilingValues extends React.Component {

    constructor(props) {
        super(props);
        this.ReportTypeSelectorComponent = this.ReportTypeSelectorComponent.bind(this);
    }

    onSelectReportType(e) {
        log.debug('onSelectReportType(): ', e);
        if(typeof this.props.onReportChangeHandler === 'function') {
            this.props.onReportChangeHandler ( {'selectedReportType': e.target.value });
        }
    }

    ReportTypeSelectorComponent(flowTypeOptions) {
        return (
            <s-row>
                <s-col span="3">        
                    <div className="form-group">
                        <label>
                            <LanguageStringResolver string='filingReportType_ReportType' />
                        </label>
                        <FilingReportTypeSelector flowTypes={flowTypeOptions} selectValue={this.props.selectedReportType}  onChange={(e) => this.onSelectReportType(e)}></FilingReportTypeSelector>
                    </div>
                </s-col>
                <div className="clear" />
            </s-row>
        );
    }


    render() {
        let flowTypesForCountry = ENUMS.GetApplicableVatBookFlowTypes(this.props.countryCode);
        if (!flowTypesForCountry.isApplicable) {
            return (<></>);
        }

        return (
            <div>
                {this.ReportTypeSelectorComponent(flowTypesForCountry.flowTypes)}
            </div>
        );
    }

}



VATBookFilingValues.defaultProps = {
    onReportChangeHandler: () => {},
    frequency: '',
    selectedReportType: ''
}

export default VATBookFilingValues;